/** Omit empty date strings so APIs treat the range as "all time". */
export function optionalFromToDateParams(
  from?: string | null,
  to?: string | null,
): { from_date?: string; to_date?: string } {
  const result: { from_date?: string; to_date?: string } = {}
  const fromValue = from?.trim()
  const toValue = to?.trim()
  if (fromValue) result.from_date = fromValue
  if (toValue) result.to_date = toValue
  return result
}

export function optionalStartEndDateParams(
  start?: string | null,
  end?: string | null,
): { start_date?: string; end_date?: string } {
  const result: { start_date?: string; end_date?: string } = {}
  const startValue = start?.trim()
  const endValue = end?.trim()
  if (startValue) result.start_date = startValue
  if (endValue) result.end_date = endValue
  return result
}

export function hasDateRange(from?: string | null, to?: string | null): boolean {
  return Boolean(from?.trim() || to?.trim())
}
